// NOTICE: Analisis team planned to expose their uuid generation code from
// ahoy.js file in the near future, once that function exposed from ahoy.js,
// this code is no longer need.
export default class UUID {
  static v4() {
    return this._v4(new Date().getTime(), Math.random);
  }

  static _v4(d, randomFunction){
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + randomFunction()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
    });
    return uuid;
  }
}
